import React, { useState, useEffect } from 'react';
import {useEscapeClose} from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const PayModal = ({ showpayModal, handlepayClose, payDataList, onRowSelectpay }) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredApDataList, setFilteredApDataList] = useState(payDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับเลือกแถว

    useEscapeClose(showpayModal, handlepayClose);
    
    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showpayModal,
        filteredApDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectpay,
        handlepayClose
    );
    
    // ฟิลเตอร์ข้อมูลเมื่อ searchTerm หรือ payDataList เปลี่ยนแปลง
    useEffect(() => {
        setFilteredApDataList(
            payDataList.filter(pay =>
                pay.Pay_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
                pay.AP_Name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อข้อมูลเปลี่ยน
    }, [searchTerm, payDataList]);

    useEffect(() => {
        if (showpayModal) {
            setSearchTerm('');
            setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อเปิด modal
        }
    }, [showpayModal]);

    return (
        <>
            <div className={`modal ${showpayModal ? 'show' : ''}`} style={{ display: showpayModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">ใบสำคัญจ่าย</h5>
                            <button type="button" className="close" onClick={handlepayClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหา เลขที่เอกสาร	 หรือ ชื่อเจ้าหนี้"
                                    value={searchTerm || ''}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '139px' }}>เลขที่เอกสาร	</th>
                                            <th className="text-center" style={{ width: '620px' }}>ชื่อเจ้าหนี้</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredApDataList && filteredApDataList.length > 0 ? (
                                            filteredApDataList.map((pay, index) => (
                                                <tr
                                                    key={pay.Pay_No || index + 1}
                                                    onClick={() => onRowSelectpay(pay)}
                                                    style={{ cursor: 'pointer' }}>
                                                    <td className="text-center">{pay.Pay_No}</td>
                                                    <td>{pay.AP_Name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handlepayClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Overlay */}
            {showpayModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default PayModal;
